export const fontStyleMap: Record<string, string> = {
  light: 'font-light',
  regular: 'font-regular',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
};

export const fontWeightMap: Record<string, number> = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

export const fontStyleMapForInputPlaceholder: Record<string, string> = {
  light: 'placeholder:font-light',
  regular: 'placeholder:font-regular',
  medium: 'placeholder:font-medium',
  semibold: 'placeholder:font-semibold',
  bold: 'placeholder:font-bold',
};

export const positionMap: Record<string, string> = {
  left: 'justify-start text-left',
  center: 'justify-center text-center',
  right: 'justify-end text-right',
};

export const WHITE_COLOR_HEX = '#FFFFFF';
export const GREY_COLOR_HEX = '#F8F9FA';
export const DARK_ORANGE_COLOR_HEX = '#752B02';
export const BLUE_LINK_COLOR_HEX = '#0B57D0';
export const DARK_GREEN_COLOR_HEX = '#34560F';
export const BLACK_COLOR_HEX = '#333';
export const DARK_GREY_COLOR_HEX = '#5C5C5C';
export const SILVER_COLOR_HEX = '#F5F5F5';
export const LIGHT_GREY_ICONS = '#858585';
export const SAVE_TO_PROJECTS = 'Save to Projects';
export const RECENT_SEARCHES_TITLE = 'Recent Searches';
export const RELATED_KEYWORDS = 'Common Searches';
export const PRODUCT_SUGGESTIONS_TITLE = 'Product Suggestions';
export const RECOMMENDATION_TITLE='Recommendation';
export const ONE = 1;
export const SEARCH_FOR = 'Search for';
export const NO_RESULT_FOUND = 'No results found';
export const PRINTS_BUILDER_TASTIC = 'commercetools/ui/content/gmsb-dynamic';
